import { useEffect } from 'react';
import { listenLines } from '../../channels/linesChannel';
import { useLinesStore } from '../../stores/useLinesStore';
import { useScreenStore } from '../../stores/useScreenStore';

export function useLinesChannel() {

    useEffect(() => {

        const unsubscribe = listenLines(({ tipo, payload }) => {

            const {screen} = useScreenStore.getState();

            const {
                setLinhas,
                upsertLinha,
                removeLinha,
                setLinesFilters,
                setMetrosTotalRota,
                setMetrosTotalRotaLinha,
                removeMetrosTotalRotaLinha
            } = useLinesStore.getState();

            if(screen === 'Filtros') {

                if (tipo === 'linhas-sync') {

                    setLinhas(payload, false);

                }

                if (tipo === 'linha-upsert') {

                    upsertLinha(payload, false);

                }

                if (tipo === 'linha-remove') {

                    removeLinha(payload, false);

                }

                if (tipo === 'metros-total-rota-sync') {

                    setMetrosTotalRota(payload, false);

                }

                if (tipo === 'metros-total-rota-updated') {

                    setMetrosTotalRotaLinha(
                        payload?.codigo,
                        payload?.metrosTotalRota,
                        false
                    );

                }

                if (tipo === 'metros-total-rota-delete') {

                    removeMetrosTotalRotaLinha(payload, false);

                }

            }

            if(screen === 'Home') {
                if(tipo === 'lines:filters'){
                    setLinesFilters(payload, false);
                }
            }

        });

        return unsubscribe;

    }, []);

}